import React, { useCallback, useContext } from 'react';
import { queryCache, usePaginatedQuery } from 'react-query';
import { Loader, Pagination } from 'rsuite';
import { fetchItemsList } from '../api';
import { useLocation } from '../hooks/useLocation';
import { EquipmentContext } from '../utils/scope';
import { Card } from './Card';
import { DetailCard } from './DetailCard';
import { ItemsWrap } from './ItemsWrap';
import { List } from './List';

export const Items = () => {
  const { params, go } = useLocation();
  const scope = useContext(EquipmentContext);

  const { category, page, order, view, ...filters } = params;

  const currentPage = parseInt(page) || 1;

  const {
    status,
    resolvedData,
    latestData,
    error,
    // isFetching,
  } = usePaginatedQuery([scope, 'products', category, filters, currentPage, order], fetchItemsList);

  const hasMore = latestData?.hasMore;

  // Prefetch the next page!
  React.useEffect(() => {
    if (hasMore) {
      queryCache.prefetchQuery(
        [scope, 'products', category, filters, currentPage + 1, order],
        fetchItemsList,
      );
    }
  }, [scope, hasMore, category, filters, currentPage, order]);

  const Paging = useCallback(
    () =>
      resolvedData ? (
        <Pagination
          className="app-pagination"
          prev
          last
          next
          first
          size="lg"
          ellipsis
          boundaryLinks
          maxButtons={10}
          pages={resolvedData.pages}
          activePage={currentPage}
          onSelect={(v) => {
            go({ page: v });
          }}
        />
      ) : null,
    [go, resolvedData, currentPage],
  );

  // const pages = resolvedData

  if (status === 'loading') {
    return (
      <div className="nh-items">
        <ItemsWrap>
          <Loader size="md" content="Loading..." />
        </ItemsWrap>
      </div>
    );
  }

  if (status === 'error') {
    return <span>Error: {error.message}</span>;
  }

  if (latestData && !latestData.total) {
    return (
      <div className="nh-items">
        <Paging />
        <ItemsWrap>No Products</ItemsWrap>
      </div>
    );
  }

  return (
    <div className="nh-items">
      <Paging />
      {latestData ? (
        <ItemsWrap>
          {view === 'list' ? (
            <List items={latestData.items} />
          ) : (
            latestData.items.map((item) => {
              if (view === 'detail') {
                return <DetailCard detail key={item.ID} {...item} />;
              }
              return <Card key={item.ID} {...item} />;
            })
          )}
        </ItemsWrap>
      ) : (
        <ItemsWrap>
          <Loader size="md" content="Loading..." />
        </ItemsWrap>
      )}
      <Paging />
    </div>
  );
};
